import { useEffect, useRef } from 'react';

declare global {
    interface Window {
        chatwootSDK: { run: (opts: { websiteToken: string; baseUrl: string }) => void };
        $chatwoot?: { toggleBubbleVisibility: (v: 'show' | 'hide') => void; toggle: (v?: 'open' | 'close') => void };
        chatwootSettings?: Record<string, unknown>;
    }
}

let chatwootScriptInjected = false;

type ChatwootWidgetProps = {
    /** Quando false, o bubble some (SPA: o script continua no DOM). */
    visible: boolean;
    /** Se true, abre o chat automaticamente ao ficar visível/pronto. */
    autoOpen?: boolean;
};

export default function ChatwootWidget({ visible, autoOpen }: ChatwootWidgetProps) {
    const visibleRef = useRef(visible);
    visibleRef.current = visible;
    const autoOpenRef = useRef(autoOpen);
    autoOpenRef.current = autoOpen;

    useEffect(() => {
        const hide = () => {
            window.$chatwoot?.toggleBubbleVisibility('hide');
        };

        const show = () => {
            if (!visibleRef.current) return;
            window.$chatwoot?.toggleBubbleVisibility('show');
            if (autoOpenRef.current) {
                window.$chatwoot?.toggle('open');
            }
        };

        if (!visible) {
            hide();
            return;
        }

        const onReady = () => {
            if (!visibleRef.current) {
                hide();
                return;
            }
            show();
        };

        window.addEventListener('chatwoot:ready', onReady);

        if (!chatwootScriptInjected) {
            chatwootScriptInjected = true;
            window.chatwootSettings = {
                ...window.chatwootSettings,
                hideMessageBubble: true,
            };

            const BASE_URL = 'https://mediocretoons-chatwoot.ipsl87.easypanel.host';

            const script = document.createElement('script');
            script.src = `${BASE_URL}/packs/js/sdk.js`;
            script.async = true;
            script.onload = () => {
                if (window.chatwootSDK) {
                    window.chatwootSDK.run({
                        websiteToken: 'gAaHYgsP6jLh8rKZNXSNaxKB',
                        baseUrl: BASE_URL,
                    });
                }
            };
            document.body.appendChild(script);
        } else if (window.$chatwoot) {
            show();
        }

        return () => {
            window.removeEventListener('chatwoot:ready', onReady);
            hide();
        };
    }, [visible]);

    return null;
}
